export const QUERY_PAYMENTS_STATUS = "QUERY_PAYMENTS_STATUS";
export const QUERY_INVOICES = "QUERY_INVOICES";
export const QUERY_INVOICE = "QUERY_INVOICE";

export const QUERY_CLIENT_INVOICE = "QUERY_CLIENT_INVOICE";
export const QUERY_CLIENT_INVOICE_FEES = "QUERY_CLIENT_INVOICE_FEES";
export const QUERY_PAYABLES = "QUERY_PAYABLES";
export const QUERY_PAYROLL_SETTINGS = "QUERY_PAYROLL_SETTINGS";
export const QUERY_PAYROLL_IMMEDIATE_PAYABLES =
  "QUERY_PAYROLL_IMMEDIATE_PAYABLES";
